export default {
  appName: 'platzimusic',
  apiKey: '66b51719c274b2fffa05b5d6d7d152dc',
  secret: '02dd070d5e2d20c44f3374a59e3d083e',
  registeredTo: 'sachitaplatzi'
}